module.exports = __webpack_public_path__ + "img/alma-logo.483e53dd.svg";